import { PropsWithChildren } from 'react';
import PublicNavbar from '../navigation/public-navbar.component';

const PublicScaffold = ({ children }: PropsWithChildren) => {
  return (
    <div>
      <PublicNavbar />
      <div>{children}</div>
    </div>
  );
};

export default PublicScaffold;
